import { useCallback, useEffect, useState } from 'react';

export default function useRefreshInFocus(callback: () => void, intervalTime: number) {
  const [inFocus, setInFocus] = useState(document.visibilityState === 'visible');

  const visibilityChange = useCallback(() => {
    if (document.visibilityState === 'visible') {
      callback();
      setInFocus(true);
    } else {
      setInFocus(false);
    }
  }, [callback, setInFocus]);

  useEffect(() => {
    if (inFocus) {
      const interval = setInterval(() => {
        callback();
      }, intervalTime);
      return () => clearInterval(interval);
    }
    return () => {};
  }, [inFocus, callback, intervalTime]);

  useEffect(() => {
    document.addEventListener('visibilitychange', visibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', visibilityChange);
    };
  }, [visibilityChange]);
}
